"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrameProvider = void 0;
const interaction_handler_updater_1 = require("./interaction-handler-updater");
/**
 * @public
 * {@inheritDoc IFrameProvider}
 */
class FrameProvider {
    constructor(drawCallback, updateInteractionHandlersCallback, rollupTime, $window = window) {
        this.drawCallback = drawCallback;
        this.updateInteractionHandlersCallback = updateInteractionHandlersCallback;
        this.$window = $window;
        this.onRafCallback = () => {
            const drawCallback = this.drawCallback;
            const interactionHandlersToUpdate = this.interactionHandlersToUpdate;
            const interactionStateUpdater = this.interactionStateUpdater;
            for (const plot of this.plotsToUpdate) {
                drawCallback(plot);
                if (interactionHandlersToUpdate.has(plot)) {
                    interactionStateUpdater.addPlotToUpdateQueue(plot);
                }
            }
            this.nextFrame = null;
            this.interactionStateUpdater.updateInteractionHandlers();
            this.plotsToUpdate.clear();
            this.interactionHandlersToUpdate.clear();
        };
        this.plotsToUpdate = new Set();
        this.interactionHandlersToUpdate = new Set();
        this.nextFrame = null;
        this.interactionStateUpdater = new interaction_handler_updater_1.InteractionHandlerUpdater(this.updateInteractionHandlersCallback, rollupTime);
    }
    updateOnNextFrame(plot, updateInteractionHandler) {
        this.plotsToUpdate.add(plot);
        if (updateInteractionHandler) {
            this.interactionHandlersToUpdate.add(plot);
        }
        if (this.nextFrame == null) {
            this.nextFrame = this.$window.requestAnimationFrame(this.onRafCallback);
        }
    }
    cancelNextFrame() {
        if (this.nextFrame == null) {
            return;
        }
        this.$window.cancelAnimationFrame(this.nextFrame);
        this.nextFrame = null;
        this.plotsToUpdate.clear();
        this.interactionHandlersToUpdate.clear();
        this.interactionStateUpdater.cancelAll();
    }
}
exports.FrameProvider = FrameProvider;
//# sourceMappingURL=frame-provider.js.map